module.exports = __webpack_public_path__ + "img/product-6-report.db415043.png";